import { render, staticRenderFns } from "./edit-project-settings.vue?vue&type=template&id=8d858e58"
import script from "./edit-project-settings.vue?vue&type=script&lang=js"
export * from "./edit-project-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports